export const colors = {
  primary: '#2d3034',
  secondary: '#f5f5f5',
  tertiary: '#ffffff',
  primaryAccent: '#da2e3f',
  secondaryAccent: '#1DC7EA',
  tertiaryAccent: '#87cb16',
}